import styled from 'styled-components'
import pxToRem from '../../../../utils/pxToRem'

export const StyledNavListItem = styled.li`
    display: flex;
    align-items: center;
    min-height: ${pxToRem(56)};
    
    ${({ isColored, theme }) => {
      if (isColored === 'black') return `
                    background-color: ${theme.colors.unique.black};
                    color: ${theme.colors.unique.white};
                `;
      if (isColored === 'white') return `
                    background-color: ${theme.colors.unique.white};
                    color: ${theme.colors.unique.black};
                `;
      return '';
    }}
`

export const StyledNavLink = styled.a`
    display: inline-flex;
    align-items: center;
    width: 100%;
    min-height: ${pxToRem(56)};
    padding-inline: ${pxToRem(20)} ${pxToRem(10)};
`